import "./MainMenu.less";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Icon } from "../../shared/Icon";
import { Menu, Dropdown, Badge } from "antd";
import { navigateAction } from "../../../redux/actions";
import _ from "lodash";
import { MenuItemType } from "rc-menu/lib/interface";
import * as ewcms from "../EWCMS/styleMaster";
import Logout from "../Logout/Logout";
import { useCallback, useEffect, useState } from "react";
import { httpGet } from "../../../framework";
import { RootState } from "../../../redux/reducers";

function MainMenu(props: any) {
  const {
    mode,
    className,
    device,
    permissions,
    current,
    navigate,
    approve_req_count,
    endorse_req_count,
    reject_duty_count,
    // appointments,
  } = props;
  const polyuColor = ewcms.polyuRed;

  const staffNo = useSelector((state: RootState) => state.session.staffNo[0]);
  const [staffName, setStaffName] = useState<string>("");

  //HARD CODE Number Badge to Menu
  const numberBadge = {
    approverPage: approve_req_count,
    endorserPage: endorse_req_count,
    approve: approve_req_count + endorse_req_count,
    appointment: reject_duty_count,
  };

  const addSpantoItems = (items, level): MenuItemType[] => {
    const labelItem = (item) => {
      return (
        <>
          <div
            className={`mn__link--${level} theme-color-text-hover cust-vertical-center`}
            style={{ padding: "0px", display: "flex", gap: "0.75rem" }}
          >
            {item.label}
            {numberBadge?.[item.function.NAME] >= 1 && (
              <Badge
                count={numberBadge[item.function.NAME]}
                color={polyuColor}
              />
            )}
          </div>
        </>
      );
    };

    if (_.isArray(items)) {
      return _.map(items, (item) => {
        return {
          ...item,
          label: labelItem(item),
        };
      });
    } else {
      return {
        ...items,
        label: labelItem(items),
      };
    }
  };

  const permissionToItems = (per, level = 1) => {
    let items = _(per)
      .filter((p) => {
        return (
          p.IS_SHOW === 1 &&
          ((!p.PARENT_UID && level === 1) || (p.PARENT_UID && level > 1))
        );
      })
      .map((p) => {
        const subFuncP = _.map(p.SUB_FUNC, (funcKey) => {
          return _.find(permissions, (perm) => perm.FUNC_KEY === funcKey);
        });
        const meunItem = {
          label: p.LABEL,
          key: p.FUNC_KEY,
          function: p,
          children: !_.isEmpty(subFuncP)
            ? permissionToItems(subFuncP, level + 1)
            : null,
        };
        return meunItem;
      })
      .value();
    items = items.sort((per, current) => {
      return Number(per.key) - Number(current.key);
    });
    return addSpantoItems(items, level);
  };

  const modeVal: "vertical" | "inline" | "mobile" | "horizontal" =
    mode !== undefined &&
    (mode === "vertical" || mode === "inline" || mode === "mobile")
      ? mode
      : "horizontal";

  const onClick = (e) => {
    const func = _.find(permissions, { FUNC_KEY: e.key });
    navigate(func);
  };

  const menuList = (
    <Menu
      onClick={onClick}
      defaultSelectedKeys={[current]}
      selectedKeys={[current]}
      mode={modeVal === "mobile" ? undefined : modeVal}
      triggerSubMenuAction={device.size === "desktop" ? "hover" : "click"}
      items={permissionToItems(permissions)}
      className={className}
    />
  );

  const getStaffName = useCallback(async () => {
    if (staffNo) {
      const data: any = await httpGet(
        `/api/protected/ptps/getStaffName?staffNo=${staffNo}`
      );
      // console.log("*****getStaffName:", data.value.staffName);
      setStaffName(data.value.staffName ?? "");
    }
  }, [staffNo]);

  useEffect(() => {
    getStaffName().catch(console.error);
  }, [getStaffName]);

  const hMenu = (
    <div className="header-bottom d-none d-lg-block">
      <div
        className="container container-best header-bottom__container"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div className="mn--fact color-set--red" style={{ width: "100%" }}>
          {menuList}
        </div>
        <div className="mn--fact" style={{ width: "30%" }}>
          <div
            id="headerMeunName"
            className="d-print-none cust-vertical-center"
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {staffName ? (
              <div
                style={{ marginRight: "10px" }}
              >{`${staffName} (${staffNo})`}</div>
            ) : (
              <></>
            )}
            <div>
              <Logout />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  switch (modeVal) {
    case "mobile":
      return (
        <Dropdown
          trigger={["click"]}
          menu={menuList.props}
          className="mTrigger mobile-menu-wrap d-block d-lg-none"
        >
          <Link
            to={"#"}
            className="ant-dropdown-link"
            onClick={(e) => e.preventDefault()}
          >
            <Icon type="MenuOutlined" />
          </Link>
        </Dropdown>
      );
    default:
      return hMenu;
  }
}

const mapStateToProps = (state) => {
  return {
    /*Permission: assign different permission as inputter and approver*/
    appointments: state.data.appointments,
    permissions: state.dashboard.functions,
    device: state.session.device,
    current: state.dashboard?.currentFunction?.FUNC_KEY,
    approve_req_count: state.data.approve_req_count,
    endorse_req_count: state.data.endorse_req_count,
    reject_duty_count: state.data.reject_duty
      ? state.data.reject_duty.length
      : 0,
  };
};

const mapDispatchToProps = (dispatch) => ({
  navigate: (toFunctions) => {
    dispatch(navigateAction(toFunctions));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
